import { render } from "./whitelist.vue?vue&type=template&id=52d68d7c"
import script from "./whitelist.vue?vue&type=script&lang=js"
export * from "./whitelist.vue?vue&type=script&lang=js"

import "./whitelist.vue?vue&type=style&index=0&id=52d68d7c&lang=css"
script.render = render

export default script